/*
custom-text-live-preview.js
Copyright 2019 Able Sense
*/

document.addEventListener('DOMContentLoaded', loaded);

function loaded() {
  // disable add to cart if no text added
  var addtoCartBtn = document.getElementById('AddToCart');
  addtoCartBtn.disabled = true;
  
  var charterNumber = document.getElementById("input-charter-number");
  
  if (charterNumber) {
    // run the check on load
    if (charterNumber.value === '') {
      addtoCartBtn.disabled = true;
    } else {
      addtoCartBtn.disabled = false;
    }
    
    // then watch for a change
    charterNumber.addEventListener("keyup", function(ev) {
      if (ev.target.value === '') {
        addtoCartBtn.disabled = true;
      } else {
        addtoCartBtn.disabled = false;
      }
    }, false);
  }
}